import { useContext } from "react";
import { UserContext } from "../context/UserContext";
import { Outlet, Navigate } from "react-router-dom";
import NavBar from "../components/NavBar";
import { isLoggedInUserInfo } from "./AuthState";
//import SingleMaterial from "../pages/SingleMaterial";

function ProtectedRoutes() {
  //const { vendor, slug } = useParams();
  const { userInformation } = useContext(UserContext);
  const isLoggedIn = isLoggedInUserInfo(userInformation);

  return isLoggedIn ? (
    <>
      <NavBar />
      <Outlet />
    </>
  ) : (
    <Navigate to="/" />
  );
}

export default ProtectedRoutes;
